import React, {useState} from "react";
import { Markup } from 'interweave';
import Typography from "@mui/material/Typography";
import {ShowMoreLink} from "./form.styles";
import {IShowMoreProps} from "./types";

export const ShowMore: React.FC<IShowMoreProps> = (
    {
        text,
        showMoreText = "Show more >>",
        showLessText = "<< Show less",
        truncatedLength = 250,
        truncatedIndicator = "...",
        expanded = false,
        typeVariant = "body1",
    } : IShowMoreProps

) => {
    const [isExpanded, setIsExpanded] = useState(expanded);

    const truncatedText = () => {
        let truncText = text.substring(0, truncatedLength);
        const lastSpace = truncText.lastIndexOf(" ");
        const cutAt = lastSpace >= 0 ? lastSpace : truncText.length;
        truncText = truncText.substring(0, cutAt);
        return `${truncText}${truncatedIndicator}`;
    }

    return (
        <Typography variant={typeVariant}>
            <Markup content={isExpanded ? text : truncatedText()} />
            &nbsp;
            <ShowMoreLink
                href="#" underline="hover"
                onClick={()=>{setIsExpanded(!isExpanded)}}
            >
                {isExpanded ? showLessText : showMoreText}
            </ShowMoreLink>
        </Typography>
    );
};